module.exports = __webpack_public_path__ + "img/rolldown-shutter-pricing.f4644d74.jpg";